import React from 'react';
import BaseButton from '~/components/views/common/buttons/BaseButton/BaseButton';
import type { SharedButtonProps } from '~/components/views/common/buttons/types';

type Props = Omit<SharedButtonProps, 'color'>;

const SecondaryButton: React.FC<Props> = (props) => {
  return <BaseButton color="secondary" {...props} />;
};

export default SecondaryButton;
